(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["_n-tab-btn-list-line"] && !Shopify.designMode) return;
  try {
    const ntbLlist = document.querySelectorAll('.hs-ntab__list');
    ntbLlist.forEach(item => {
        const isCenterBtn = item.getAttribute('data-center-btn') === 'true';
        let centerSlides = false
        if(isCenterBtn) {
            centerSlides = true
        }
        const swiper = new Swiper(item, {
            centerInsufficientSlides: centerSlides,
            slidesPerView: 'auto',
            simulateTouch: true,
            grabCursor: true,
            slideToClickedSlide: true,
        });
    });
    const ntbWrap = document.querySelectorAll('.hs-ntab__wrap');
    ntbWrap.forEach(item => {
        const swiper = new Swiper(item, {
            slidesPerView: 'auto',
            simulateTouch: true,
            grabCursor: true,
            slideToClickedSlide: true,
            centerInsufficientSlides: true,
        });
    });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["_n-tab-btn-list"] && !Shopify.designMode) return;
  try {
    const ntbLlist = document.querySelectorAll('.hs-ntab__list');
    const BREAKPOINT = 900;
    const swipers = new Map();

    function syncSwiper(item) {
        const centerSlides = item.getAttribute('data-center-btn') === 'true';
        const wrap = item.getAttribute('data-wrap') === 'true';
        // 移动端且标记为不平铺时，不初始化
        const shouldInit = window.innerWidth >= BREAKPOINT || !wrap;
        const inst = swipers.get(item);

        if (shouldInit && !inst) {
            swipers.set(item, new Swiper(item, {
                centerInsufficientSlides: centerSlides,
                slidesPerView: 'auto',
                simulateTouch: true,
                grabCursor: true,
                slideToClickedSlide: true,
            }));
        } else if (!shouldInit && inst) {
            inst.destroy(true, false);
            const wrapper = item.querySelector('.swiper-wrapper');
            if(wrapper) {
                wrapper.removeAttribute('style'); 
            }
            swipers.delete(item);
        }
    }

    ntbLlist.forEach(syncSwiper);
    window.addEventListener('resize', window.hscycle.debounce(() => {
        ntbLlist.forEach(syncSwiper);
    }));
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["_n-vtab-btn-list"] && !Shopify.designMode) return;
  try {
    // 初始化swiper
    const ntbLlist = document.querySelectorAll('.hs-nvtab__list');
    const swipers = new Map(); // item -> swiper

    function initOrDestroySwipers() {
        const width = window.innerWidth;

        ntbLlist.forEach((item) => {
            const key = item; // DOM 作为 key
            const hasSwiper = swipers.has(key);
            if (width <= 900 && !hasSwiper) {
                const isCenterBtn = item.getAttribute('data-center-btn') === 'true';
                let centerSlides = false
                if(isCenterBtn) {
                    centerSlides = true
                }
                const swiper = new Swiper(item, {
                    centerInsufficientSlides: centerSlides,
                    slidesPerView: 'auto',
                    simulateTouch: true,
                    grabCursor: true,
                    slideToClickedSlide: true,
                });
                swipers.set(key, swiper);
            }

            if (width > 900 && hasSwiper) {
              const swiper = swipers.get(key); 
              swiper.destroy(true, false); // 销毁实例 + 保留样式
              swipers.delete(key);
            }
        });
    }

    // 初始执行
    initOrDestroySwipers();

    if(window.hscycle) {
        const debouncedInitOrDestroySwipers = window.hscycle.debounce(initOrDestroySwipers);
        window.addEventListener('resize', debouncedInitOrDestroySwipers);
    }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["e-cusvdo"] && !Shopify.designMode) return;
  try {
    document.addEventListener('DOMContentLoaded', function () {
  console.log('DOMContentLoaded');
  const cusvdo = document.querySelectorAll('.hs-ecusvdo')
  cusvdo.forEach(item => {
    document.dispatchEvent(new CustomEvent('hs:vdo:list:init', { detail: { root: item } }));
  })
})
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["img-list"] && !Shopify.designMode) return;
  try {
    document.addEventListener('DOMContentLoaded', function () {
    if (!window.hscycle) return;
    const BREAKPOINT = 900;
    const instances = new Map();

    function initSwiper(section) {
        if (!section) return;
        if (!window.Swiper) return;

        const loop = section.dataset?.loop === 'true';
        const autoplay = section.dataset?.autoplay === 'true';
        const pagination = section.dataset?.pgn === 'scrollbar';
        const scrollbar = section.dataset?.pgn === 'pagination';
        // 移动端标记为 wrap 时，不初始化，走平铺
        const wrap = section.getAttribute('data-wrap') === 'true';
        const shouldInit = window.innerWidth >= BREAKPOINT || !wrap;

        const inst = instances.get(section);

        if (shouldInit && !inst) {
            const fullId = section.id;
            const autoplayOptions = autoplay ? {
                delay: 5000,
                disableOnInteraction: false,
            } : false;

            const s = new Swiper(section, {
                slidesPerView: 'auto',
                grabCursor: true,
                simulateTouch: true,
                loop: loop,
                freeMode: true,
                autoplay: autoplayOptions,
                scrollbar: scrollbar ? false : {
                    el: ".hs-imglist__sbar[" + fullId + "]",
                },
                pagination: pagination ? false : {
                    el: ".hs-splide__pgn[" + fullId + "]",
                    clickable: true,
                }
            });
            instances.set(section, s);
        } else if (!shouldInit && inst) {
            inst.destroy(true, true);
            instances.delete(section);
        }
    }

    const sections = document.querySelectorAll('.hs-imglist');
    sections.forEach(initSwiper);

    window.addEventListener('resize', window.hscycle.debounce(() => {
        sections.forEach(initSwiper);
    }));
});
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["n-faq"] && !Shopify.designMode) return;
  try {
    window.addEventListener('DOMContentLoaded', function () {
  if (!window.hscycle) return
    window.hscycle.accordion('.hs-nfaq__btn')
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["n-pslide"] && !Shopify.designMode) return;
  try {
    function initSwiper(section) {
        if (!section) {
            return;
        }
        if(Swiper) {
            const loop = section.dataset?.loop === 'true';
            const autoplay = section.dataset?.autoplay === 'true';

            const fullId = section.id;

            const autoplayOptions = autoplay ? {
                    delay: 5000,
                    disableOnInteraction: false,
                } : false

          
            new Swiper(section, {
                slidesPerView: 'auto',
                grabCursor: true,
                simulateTouch: true,
                loop: loop,
                // freeMode: true,
                autoplay: autoplayOptions,
                pagination: {
                    el: ".hs-splide__pgn[" + fullId + "]",
                    clickable: true,
                }
            });
        }
    }

    const sections = document.querySelectorAll('.hs-pslide');
    sections.forEach(function (section) {
        initSwiper(section);
    });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["n-tab"] && !Shopify.designMode) return;
  try {
    if(!A11yTabs) return 
    const elements = document.querySelectorAll('[id^="ntab-"]');

    elements.forEach(element => {
        const id = element.id
        if(id != null) {
            new A11yTabs(`#${id} [role="tablist"]`, `#${id} [role="tabpanel"]`, 0);
        }
    });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["n-vtab"] && !Shopify.designMode) return;
  try {
    if(!A11yTabs) return 
    const elements = document.querySelectorAll('[id^="nvtab-"]');

    elements.forEach(element => {
        const id = element.id
        if(id != null) {
            new A11yTabs(`#${id} [role="tablist"]`, `#${id} [role="tabpanel"]`, 0);
        }
    });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["news"] && !Shopify.designMode) return;
  try {
    // 获取页面中所有匹配的轮播图容器
const splides = document.querySelectorAll('.hs-news');
    if (splides.length === 0) {
      return;
    }
if(Swiper) {
    // 遍历每个容器，进行独立的初始化
    splides.forEach(splide => {
        const autoplayFlag = splide.dataset.hsAutoplay === 'true';
        const loop = autoplayFlag ? true : false;
        const autoplay = autoplayFlag ? { delay: 5000, disableOnInteraction: false } : false;
        const fullId = splide.id;
        new Swiper(splide, {
            slidesPerView: 'auto',
            grabCursor: true,
            simulateTouch: true,
            slidesPerGroup: 1,
            loop: loop,
            freeMode: true,
            autoplay: autoplay,
            breakpoints: {
                900: {
                    slidesPerGroup: 3,
                }
            },
            navigation: {
                prevEl: ".hs-splide__nav--prev[" + fullId + "]",
                nextEl: ".hs-splide__nav--next[" + fullId + "]"
            },
            pagination: {
                el: ".hs-splide__pgn[" + fullId + "]",
                clickable: true,
            }
        });
    });
}
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["p-coupon"] && !Shopify.designMode) return;
  try {
    // coupon code 复制功能
async function handleCopy(e) {
  const btn = e.target.closest('[data-copy-btn]');
  if (!btn) return;

  const codeEl = btn.parentElement.querySelector('[data-copy-data]');
  if (!codeEl) return;

  const code = codeEl.textContent.trim();
  const copiedText = btn.getAttribute('data-copied-text');
  const originalText = btn.getAttribute('data-copy-text');

  try {
    await navigator.clipboard.writeText(code);
    btn.textContent = copiedText;
    setTimeout(() => {
      btn.textContent = originalText;
    }, 1500);
  } catch (err) {
    console.error('Copy failed:', err);
  }
}

// 事件委托：只绑定一次
document.addEventListener('click', (e) => {
  if (e.target.closest('[data-copy-area]')) {
    handleCopy(e);
  }
});


// 倒计时
  document.querySelectorAll('[data-hs-cp-timer]').forEach(function (container) {
    var timerEl = container
    if (!timerEl) return;

    var endTimeStr = timerEl.getAttribute('data-end-time');
    var startTimeStr = timerEl.getAttribute('data-start-time'); // 【新增】获取开始时间
    var shopOffsetStr = timerEl.getAttribute('data-shop-offset');

    if (!endTimeStr || !shopOffsetStr) return;


    // --- 辅助函数：解析时区偏移量字符串 (例如 "+0800" 或 "-0400") ---
    function parseOffsetToMinutes(offsetStr) {
      if (!offsetStr || offsetStr.length < 5) return 0;
      var sign = offsetStr[0] === '-' ? -1 : 1;
      var hours = parseInt(offsetStr.slice(1, 3), 10);
      var minutes = parseInt(offsetStr.slice(3, 5), 10);
      if (isNaN(hours) || isNaN(minutes)) return 0;
      return sign * (hours * 60 + minutes);
    }

    var shopOffsetMinutes = parseOffsetToMinutes(shopOffsetStr);

    // --- 辅助函数：将【带时区偏移的本地时间】转换为【绝对 UTC 时间戳】 ---
    function parseShopLocalTimeToUTC(timeStr, offsetMinutes) {
      if (!timeStr) return NaN;
      timeStr = timeStr.replace('T', ' ').trim();
      var parts = timeStr.split(' ');
      if (parts.length < 2) return NaN;

      var dateBits = parts[0].split('-');
      if (dateBits.length !== 3) return NaN;

      var year = parseInt(dateBits[0], 10);
      var month = parseInt(dateBits[1], 10);
      var day = parseInt(dateBits[2], 10);

      var timeBits = parts[1].split(':');
      var hour = parseInt(timeBits[0], 10);
      var minute = parseInt(timeBits[1] || '0', 10);
      var second = parseInt(timeBits[2] || '0', 10);

      if ([year, month, day, hour, minute, second].some(isNaN)) return NaN;

      // 核心算法：先按 UTC 算出毫秒数，然后【减去】时区偏移量，得到真实的 UTC 时间戳
      var localMillis = Date.UTC(year, month - 1, day, hour, minute, second);
      return localMillis - offsetMinutes * 60 * 1000;
    }

    // 1. 解析结束时间，如果解析失败直接退出
    var endUTC = parseShopLocalTimeToUTC(endTimeStr, shopOffsetMinutes);
    if (isNaN(endUTC)) return;

    // 2. 【新增】解析开始时间，如果没传或解析失败，返回 NaN
    var startUTC = parseShopLocalTimeToUTC(startTimeStr, shopOffsetMinutes);
    

    function updateCountdown() {
      // 获取当前的绝对 UTC 时间戳
      var nowUTC = Date.now();
      // 【核心对比逻辑】：
      // 只有当 startUTC 是有效数字，且 当前时间 < 开始时间 时，才隐藏
      if (!isNaN(startUTC) && nowUTC < startUTC) {
        container.style.display = 'none'; 
        return; 
      } else {
        container.style.display = ''; 
      }

      // 到达开始时间，或没有配置开始时间，确保容器显示
      container.style.display = ''; 

      // 计算距离结束时间的差值
      var distance = endUTC - nowUTC;

      // 结束后的逻辑
      if (distance <= 0) {
        container.style.display = 'none';
        clearInterval(intervalId);
        return;
      }
    }

    updateCountdown();
    var intervalId = setInterval(updateCountdown, 1000);
  })
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["p-invqty"] && !Shopify.designMode) return;
  try {
    const blocks = document.querySelectorAll('.hs-pinvqty');
  if (!blocks.length) return;

  blocks.forEach((block) => {
    const variantId    = block.getAttribute('data-variant-id');
    const min          = parseInt(block.getAttribute('data-min')) || 3;
    const max          = parseInt(block.getAttribute('data-max')) || 25;
    const total        = parseInt(block.getAttribute('data-total')) || 50;
    const shouldReduce = block.getAttribute('data-reduce') === 'true';
    const step         = parseInt(block.getAttribute('data-step')) || 1;
    const bgten        = parseInt(block.getAttribute('data-bgten')) || 40;

    const storageKey = 'fake_stock_' + variantId;
    const cached = localStorage.getItem(storageKey);
    let stockQty;

    if (cached !== null && !isNaN(parseInt(cached))) {
      stockQty = parseInt(cached);
    } else {
      stockQty = Math.floor(Math.random() * (max - min + 1)) + min;
      localStorage.setItem(storageKey, stockQty);
    }

    const countEl = block.querySelector('[data-count]');
    if (countEl) countEl.textContent = stockQty;

    const fillEl = block.querySelector('[data-progress-fill]');
    if (fillEl) {
      const percent = Math.min(100, Math.round((stockQty / total) * 100));
      // 先设为 100%（无动画）
      fillEl.style.transition = 'none';
      fillEl.style.width = '100%';
      // 强制 reflow
      fillEl.offsetHeight;
      // 恢复 transition，再过渡到目标值
      fillEl.style.transition = 'width 1s ease';
      fillEl.style.width = percent + '%';
    }

    if (shouldReduce && stockQty > min) {
      const reduceInterval = setInterval(() => {
        const current = parseInt(localStorage.getItem(storageKey));
        if (current <= min) {
          clearInterval(reduceInterval);
          return;
        }
        let newVal = current - step;
        if (newVal < min) newVal = min;
        localStorage.setItem(storageKey, newVal);
        if (countEl) countEl.textContent = newVal;
        if (fillEl) {
          const newPercent = Math.min(100, Math.round((newVal / total) * 100));
          fillEl.style.width = newPercent + '%';
        }
      }, bgten * 1000);
    }
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["p-msg"] && !Shopify.designMode) return;
  try {
    // description 折叠功能
function toggleCollapsible(rootDom) {
  if (!rootDom) return
  const productContent = rootDom.querySelector('.hs-pmsg__wrap')
  const viewBtn = rootDom.querySelector('.hs-pmsg__btn');
  const pcDfh = rootDom.getAttribute('data-pc-dfh')
  const mDfh = rootDom.getAttribute('data-m-dfh')
  // 检查内容高度是否小于最小高度
  const pcDfhPx = pcDfh * 16; // 与 CSS 中的 max-height 保持一致
  const mDfhPx = mDfh * 16
  let minHeight = window.innerWidth > 900 ? pcDfhPx : mDfhPx
  if (productContent.scrollHeight <= minHeight) {
    // 如果内容不足以触发折叠，就隐藏展开按钮
    rootDom.classList.add('disabled')
    return; // 不需要绑定事件
  }
  viewBtn.addEventListener('click', () => {
    rootDom.classList.toggle('active');
  });
}

const rootDoms = document.querySelectorAll('.hs-pmsg')
rootDoms.forEach(rootDom => {
  toggleCollapsible(rootDom)
})
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["p-spec"] && !Shopify.designMode) return;
  try {
    if (!window.hscycle) return
const doms = document.querySelectorAll('.hs-pspec');
doms.forEach(function (dom) {
  const expandFirst = dom.dataset.expand === 'true' ? 0 : false;
  const id = '#' + dom.id;
  window.hscycle.accordion(id + ' .hs-pspec__btn', { defaultOpen: expandFirst })
})
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["p-var"] && !Shopify.designMode) return;
  try {
    // 获取所有的 radio 输入框
const radios = document.querySelectorAll('[data-hs-var-item]');

// 提取同步逻辑为独立函数，方便复用
function syncAriaChecked(radio) {
  // 1. 将所有 label 的 aria-checked 设为 false
  document.querySelectorAll('.hs-pvar__item').forEach(label => {
    label.setAttribute('aria-checked', 'false');
  });
  
  // 2. 将当前选中的 radio 对应的 label 的 aria-checked 设为 true
  if (radio.checked) {
    const selectedLabel = document.querySelector(`label[for="${radio.id}"]`);
    if (selectedLabel) {
      selectedLabel.setAttribute('aria-checked', 'true');
    }
  }
}

// 1. 绑定 change 事件（处理用户手动切换）
radios.forEach(radio => {
  radio.addEventListener('change', function() {
    syncAriaChecked(this);
  });
});

// 2. 初始化：页面加载时，主动检查并同步一次当前选中的状态
const initialCheckedRadio = document.querySelector('.hs-pvar__radio:checked');
if (initialCheckedRadio) {
  syncAriaChecked(initialCheckedRadio);
}
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["review"] && !Shopify.designMode) return;
  try {
    const splides = document.querySelectorAll('.hs-review');
    if (splides.length === 0) {
      return;
    }
    if(Swiper) {
      splides.forEach(splide => {
        const fullId = splide.id;
        new Swiper(splide, {
          slidesPerView: 'auto',
          grabCursor: true,
          simulateTouch: true,
          loop: true,
          freeMode: true,
          autoplay: {
            delay: 5000,
            disableOnInteraction: false,
          },
          pagination: {
              el: ".hs-splide__pgn[" + fullId + "]",
              clickable: true,
          }
        });
      });
    }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["video-list"] && !Shopify.designMode) return;
  try {
    // 初始化要添加文档加载完毕事件监听，要比snippet代码后执行
document.addEventListener('DOMContentLoaded', function () {
    function initSwiper(section) {
        if (!section) {
            return;
        }
        if(Swiper) {
            const loop = section.dataset.loop === 'true';
            const autoplay = section.dataset.autoplay === 'true';
            const fullId = section.id;

            const autoplayOptions = autoplay ? {
                    delay: 5000,
                    disableOnInteraction: false,
                } : false


            new Swiper(section, {
                slidesPerView: 'auto',
                grabCursor: true,
                simulateTouch: true,
                loop: loop,
                freeMode: true,
                autoplay: autoplayOptions,
                pagination: {
                    el: ".hs-splide__pgn[" + fullId + "]",
                    clickable: true,
                }
            });
            document.dispatchEvent(new CustomEvent('hs:vdo:list:init', { detail: { root: section } }));
        }
    }

    const sections = document.querySelectorAll('.hs-vdolist');
    sections.forEach(function (section) {
        initSwiper(section);
    });
})
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["video"] && !Shopify.designMode) return;
  try {
    (function () {
  if (window.__hsVideoInit) return;
  window.__hsVideoInit = true;

  var ytPlayers = new Map();
  var apiPromise = null;

  function loadYoutubeAPI() {
    if (window.YT && window.YT.Player) return Promise.resolve();
    if (apiPromise) return apiPromise;

    apiPromise = new Promise(function (resolve) {
      var prev = window.onYouTubeIframeAPIReady;
      window.onYouTubeIframeAPIReady = function () {
        if (typeof prev === 'function') prev();
        resolve();
      };
      var tag = document.createElement('script');
      tag.src = 'https://www.youtube.com/iframe_api';
      document.head.appendChild(tag);
    });

    return apiPromise;
  }

  function pauseOthers(current) {
    document.querySelectorAll('video.hs-video__media').forEach(function (v) {
      if (v !== current && !v.paused) v.pause();
    });
    if (window.YT && window.YT.PlayerState) {
      ytPlayers.forEach(function (player, iframe) {
        if (iframe !== current && player.getPlayerState && player.getPlayerState() === YT.PlayerState.PLAYING) {
          player.pauseVideo();
        }
      });
    }
  }

  function playUploaded(container, media) {
    container.classList.add('is-playing');
    media.setAttribute('controls', '');
    media.muted = false;

    var played = media.play();
    if (played && played.catch) {
      played.catch(function () {
        // 浏览器拦截有声自动播放时退回静音播放，让用户自己开声音
        media.muted = true;
        media.play().catch(function () {
          container.classList.remove('is-playing');
          media.removeAttribute('controls');
        });
      });
    }
  }

  function playYoutube(container, iframe) {
    var player = ytPlayers.get(iframe);
    if (player) {
      container.classList.add('is-playing');
      player.playVideo();
      return;
    }

    container.classList.add('is-loading');
    iframe.src = 'https://www.youtube.com/embed/' + iframe.dataset.videoId +
      '?enablejsapi=1&rel=0&autoplay=1&playsinline=1&origin=' + encodeURIComponent(location.origin);

    loadYoutubeAPI().then(function () {
      player = new YT.Player(iframe, {
        events: {
          onReady: function (ev) {
            container.classList.remove('is-loading');
            container.classList.add('is-playing');
            ev.target.playVideo();
          },
          onStateChange: function (ev) {
            if (ev.data === YT.PlayerState.PLAYING) pauseOthers(ev.target.getIframe());
          }
        }
      });
      ytPlayers.set(iframe, player);
    });
  }

  document.addEventListener('click', function (e) {
    var trigger = e.target.closest('.hs-video__trigger');
    if (!trigger) return;

    var container = trigger.closest('.hs-video');
    if (!container || container.classList.contains('is-loading')) return;

    var media = container.querySelector('video.hs-video__media');
    if (media) {
      playUploaded(container, media);
      return;
    }

    var iframe = container.querySelector('.hs-video__yt');
    if (iframe) playYoutube(container, iframe);
  });

  document.addEventListener('play', function (e) {
    if (e.target.classList && e.target.classList.contains('hs-video__media')) {
      pauseOthers(e.target);
    }
  }, true);

  document.addEventListener('ended', function (e) {
    var media = e.target;
    if (!media.classList || !media.classList.contains('hs-video__media')) return;

    var container = media.closest('.hs-video');
    if (container) container.classList.remove('is-playing');
    media.removeAttribute('controls');
    media.load();
  }, true);
})();
  } catch(e) { console.error(e); }
})();

})();
